/**
 * @Description 地图loading效果
 */
import { CSSProperties, FC, useEffect, useState } from 'react';
import { isNotEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from '../index.module.less';

// 默认gif，可自定义
const loadingGif = `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map_page_loading.gif`;
const Loading: FC<{
  /** 地图实例 */
  amapIns?: any;
  /** 动画图 */
  gifUrl?: string;
  /** loading延时取消时间 */
  delay?: number;
  /** 外部loading */
  externalLoading?: boolean;
  /** 设置外部loading */
  setExternalLoading?: (loading: boolean) => void;
  className?: string;
  wrapperStyle?: CSSProperties;
}> = ({
  amapIns, // 地图实例
  gifUrl = loadingGif, // 动画图
  delay = 300, // loading延时取消时间
  // 传externalLoading和setExternalLoading时就不要传入 amapIns
  externalLoading, // 外部loading
  setExternalLoading,
  className,
  wrapperStyle
}) => {
  const [pageLoading, setPageLoading] = useState<boolean>(false);


  useEffect(() => {
    // 外部控制loading状态时
    if (isNotEmpty(externalLoading) && setExternalLoading) {
      setPageLoading(!!externalLoading);
      return;
    }
    setPageLoading(true); // 默认显示loading
  }, [externalLoading, setExternalLoading]);

  useEffect(() => {
    if (!amapIns) return;
    setTimeout(() => {
      setPageLoading(false);
    }, delay);
  }, [amapIns]);

  return (
    <>
      {
        pageLoading ? <div
          className={cs(styles.mapComOfLoadingCon, className)}
          style={wrapperStyle}>
          <img
            src={gifUrl}
            width='100%'
            height='100%'/>
        </div> : <></>
      }
    </>
  );
};

export default Loading;
